import React from 'react';

// Cómo avisarle al cliente de un cambio que le importa
const OPCIONES = [
  ['no', 'No avisar'],
  ['portal', 'Solo en el portal'],
  ['email', 'Solo por email'],
  ['ambos', 'Portal y email'],
];

export default function SelectorAviso({ value, onChange, etiqueta = 'Avisarle al cliente' }) {
  return (
    <div className="form-group">
      <label>{etiqueta}</label>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        {OPCIONES.map(([v, l]) => (
          <button key={v} type="button" onClick={() => onChange(v)}
            style={{
              padding: '6px 12px', borderRadius: 999, fontSize: 12, fontWeight: 600, cursor: 'pointer',
              border: '1px solid ' + (value === v ? 'var(--accent)' : 'var(--border)'),
              background: value === v ? 'var(--accent)' : 'transparent',
              color: value === v ? '#fff' : 'var(--text-secondary)',
            }}>{l}</button>
        ))}
      </div>
    </div>
  );
}
